<template lang="pug">
  .navigation(ref="nav")
    li.nav(v-for="(link, index) in links" :key="link.section" :class="color")
      a.nav-button(:href="'#' + link.section" :title="link.title"  @click="setCurrentSection(index)" :class="[index === currentSection ? 'active' : '']")
        .nav-dot
        span.nav-title(v-html="link.title")
</template>

<script>

export default {
  name: 'navigation',
  props: {
  },
  data () {
    return {
      color: String,
      currentSection: 0,
      links: [
        {
          title: 'The Journey to Buying a Holiday Gift',
          section: 'intro',
        },
        {
          title: 'Researching the Perfect Gift',
          section: 'research',
        },
        {
          title: 'Evaluating Gift Options',
          section: 'evaluating',
        },
        {
          title: 'Purchasing the Gift',
          section: 'purchasing',
        },
        {
          title: 'The Gift That Keeps on Giving',
          section: 'giving',
        },
      ],
    }
  },
  mounted () {
    window.addEventListener('scroll', this.checkSection)
  },
  methods: {
    setCurrentSection (index) {
      this.currentSection = index
    },
    checkSection() {
      this.links.forEach((element, index) => {
        var bounding = document.querySelector(`#${element.section}`).getBoundingClientRect()
        if(bounding.top < (window.innerHeight / 2)) {
          this.currentSection = index
        }
      })
    },
  },
  computed: {
  },
  components: {
  },
}
</script>

<style scoped lang="scss">
.navigation {
  position: fixed;
  top: 50%;
  left: 15px;
  z-index: 999;

  .nav {
    list-style: none;
    list-style-image: none;
    padding: 5px 0;

    a {
      display: flex;
      align-items: center;
      padding: 0 10px;
      min-width: 30px;
      text-decoration: none;

      &:hover {
        cursor: pointer;
      }
    }

    .nav-button {
      &.active {
        .nav-dot {
          &:after {
            opacity: 1;
          }
        }
      }
    }

    &-dot {
      width: 12px;
      height: 12px;
      position: relative;
      margin-right: 7px;

      &:after {
        content: ' ';
        position: absolute;
        top: 0;
        left: 0;
        width: 12px;
        height: 12px;
        background-color: $brandPrimary;
        border-radius: 50%;
        opacity: 0.5;
        transition: 300ms opacity;
        box-shadow: 0px 0px 0px 1px rgba(255,255,255,1);
      }
    }

    &-title {
      opacity: 0;
      font-size: .7rem;
      padding: .25rem .5rem;
      text-decoration: none;
      transition: 500ms opacity;
      border-radius: 4px;
      color: #000;

      &:hover {
        text-decoration: none;
      }
    }

    &:hover {
      cursor: pointer;

      .nav {
        &-title {
          opacity: 1;
        }
      }
    }
  }

  @media #{$mobile} {
    left: 4px;
    .nav-title {
      display: none;
    }

    .nav-button {
      padding: 0 
    }

    .nav {
      &-dot {
      width: 9px;
      height: 9px;
      position: relative;
      margin-right: 7px;

        &:after {
          content: ' ';
          position: absolute;
          top: 0;
          left: 0;
          width: 9px;
          height: 9px;
          background-color: $brandPrimary;
          border-radius: 50%;
          opacity: 0.5;
          transition: 300ms opacity;
          box-shadow: 0px 0px 0px 1px rgba(255,255,255,1);
        }
      }
    }
  }
}
</style>
